import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'

const DisconnectTwoFAModal = ({isActive, setIsActive, disconnect2Fa, isDisconnecting}: any) => {
  const {formatMessage} = useIntl()
  return (
    <div>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
      >
        <Modal.Header closeButton>
          <div className='d-flex flex-column'>
            <h2>{formatMessage({id: `Turn off 2FA`})}</h2>
          </div>
        </Modal.Header>
        <Modal.Body className='container'>
          <p>
            {formatMessage({
              id: `If you Turn Off your existing 2FA, you will need to reconfigure the authenticator verification on your device to start using it again. Any unused backup codes will be deleted.`,
            })}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-md-flex w-100 w-md-auto justify-content-end px-0 gap-3'>
            <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
              <button
                type='submit'
                className='btn bg-danger text-white custom-button-property w-100'
                onClick={disconnect2Fa}
                disabled={isDisconnecting}
              >
                {isDisconnecting ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {formatMessage({id: 'Please wait'})}...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <span className='indicator-label'>{formatMessage({id: 'Turn Off'})}</span>
                )}
              </button>
            </div>
            <div className='w-100 w-md-auto order-2 order-md-1'>
              <button
                type='button'
                className='btn bg-light text-muted custom-button-property w-100'
                onClick={() => setIsActive(!isActive)}
              >
                {formatMessage({id: 'Cancel'})}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default DisconnectTwoFAModal
